export const FAIRY_THEMES = {
  aurora: {
    name: 'Aurora',
    primary:   '#7ec8e3',
    secondary: '#b8e0f7',
    glow:      'rgba(126, 200, 227, 0.4)',
    particle:  '❄️',
  },
  ember: {
    name: 'Ember',
    primary:   '#ff6b35',
    secondary: '#ff9a5c',
    glow:      'rgba(255, 107, 53, 0.4)',
    particle:  '🔥',
  },
  sage: {
    name: 'Sage',
    primary:   '#52b788',
    secondary: '#95d5b2',
    glow:      'rgba(82, 183, 136, 0.4)',
    particle:  '🌿',
  },
  luna: {
    name: 'Luna',
    primary:   '#9b72cf',
    secondary: '#c9b1e8',
    glow:      'rgba(155, 114, 207, 0.4)',
    particle:  '🌙',
  },
  nova: {
    name: 'Nova',
    primary:   '#ff6eb4',
    secondary: '#7ee8fa',
    glow:      'rgba(255, 110, 180, 0.4)',
    particle:  '✨',
  },
};
